import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
// import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { UserAccountsComponent } from './user-accounts.component';

@NgModule({
  imports: [
    CommonModule
    // ProgressbarModule.forRoot(),
  ],
  declarations: [UserAccountsComponent],
  exports: [UserAccountsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserAccountsModule {}
